

// import React from "react";
// import { motion } from "framer-motion";
// import type { Variants } from "framer-motion";

// export default function Skill() {
//     return (
//         <div style={container}>
//             <div style={{ textAlign: "center", marginBottom: -10 }}>
//             <h1 style={{ fontSize: 36, fontWeight: "bold" }}>Skill Development</h1>
//             <p style={{ fontSize: 16, maxWidth: 800, margin: "10px auto", lineHeight: 1.6, opacity: 0.8 }}>
//                 Build confidence, master job-ready skills, and gain real-world exposure through mentor-led training designed to help you stand out.
//             </p>
//         </div>
//             {cards.map((item, i) => (
//                 <Card item={item} i={i} key={i} />
//             ))}
//         </div>
//     );
// }

// interface CardProps {
//     item: {
//         title: string;
//         desc: string;
//         img: string;
//     };
//     i: number;
// }

// function Card({ item, i }: CardProps) {
//     return (
//         <motion.div
//             className={`card-container-${i}`}
//             style={cardContainer}
//             initial="offscreen"
//             whileInView="onscreen"
//             viewport={{ amount: 0.8 }}
//         >
//             {/* Background (Online Image) */}
//             <div
//                 style={{
//                     ...splash,
//                     backgroundImage: `url(${item.img})`,
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                 }}
//             />

//             {/* Card Content */}
//             <motion.div style={card} variants={cardVariants} className="card">
//                 <div style={{ textAlign: "center" }}>
//                     <h2 style={{ fontSize: 28, marginBottom: 10 }}>{item.title}</h2>
//                     <p style={{ fontSize: 16, opacity: 0.8 }}>{item.desc}</p>
//                 </div>
//             </motion.div>
//         </motion.div>
//     );
// }

// /* ANIMATION */
// const cardVariants: Variants = {
//     offscreen: {
//         y: 300,
//     },
//     onscreen: {
//         y: 50,
//         rotate: -10,
//         transition: {
//             type: "spring",
//             bounce: 0.4,
//             duration: 0.8,
//         },
//     },
// };

// /* ==============   Styles   ================ */

// const container: React.CSSProperties = {
//     margin: "100px auto",
//     // maxWidth: 500,
//     maxWidth: 1200,
//     paddingBottom: 100,
//     width: "100%",
//     // marginLeft: "200px",
//     gridTemplateColumns: "repeat(2, 1fr)",
// };


// const cardContainer: React.CSSProperties = {
//     overflow: "hidden",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     position: "relative",
//     paddingTop: 20,
//     // marginBottom: -120,
//     marginBottom: -65,
// };

// const splash: React.CSSProperties = {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     clipPath: `path("M 0 303.5 C 0 292.454 8.995 285.101 20 283.5 L 460 219.5 C 470.085 218.033 480 228.454 480 239.5 L 500 430 C 500 441.046 491.046 450 480 450 L 20 450 C 8.954 450 0 441.046 0 430 Z")`,
// };

// const card: React.CSSProperties = {
//     width: 300,
//     height: 430,
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     borderRadius: 20,
//     background: "#fff",
//     padding: 20,
//     boxShadow:
//         "0 0 1px rgba(0,0,0,0.1), 0 0 4px rgba(0,0,0,0.1), 0 0 12px rgba(0,0,0,0.1)",
//     transformOrigin: "10% 60%",
// };

// /* ==============   Card Data (Replace as Needed)   ================ */

// const cards = [
//     {
//         title: "Interview Mastery",
//         desc: "Gain insider strategies to answer tough questions, showcase your strengths, and approach every interview with clarity and confidence.",
//         img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
//     },
//     {
//         title: "Professional Preparation",
//         desc: "Learn how to research job roles, decode company expectations, and walk into interviews ready, composed, and informed.",
//         img: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a",
//     },
//     {
//         title: "ATS-Friendly Resume Design",
//         desc: "Create resumes that pass Applicant Tracking Systems, highlight your achievements, and get you shortlisted faster.",
//         img: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
//     },
//     {
//         title: "Recruiter Insight & Screening",
//         desc: "Understand how HR evaluates candidates, what they filter out, and how to align your profile with real hiring expectations.",
//         img: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
//     },
//      {
//         title: "LinkedIn Profile Branding",
//         desc: "Transform your LinkedIn into a personal brand—optimize your headline, summary, achievements, and digital presence to attract opportunities.",
//         img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
//     },
//     {
//         title: "Post-Interview Success Tactics",
//         desc: "Master the art of follow-ups, thank-you messages, offer discussions, and post-interview communication that leaves a strong impression.",
//         img: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a",
//     },
//     {
//         title: "Workplace Etiquette & Culture",
//         desc: "Learn how to behave, communicate, and collaborate in corporate environments with professionalism, discipline, and maturity.",
//         img: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
//     },
//     {
//         title: "Communication & Ethics Excellence",
//         desc: "Develop clarity in speech, confidence in writing, empathy in interaction, and a deep understanding of ethics that employers respect.",
//         img: "https://images.unsplash.com/photo-1531092601737-e5b3b6e57365?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//     },
//     {
//         title: "Real-Time HR Mock Interviews",
//         desc: "Practice with HR professionals, receive actionable feedback, and improve your performance through real interview simulations.",
//         img: "https://images.unsplash.com/photo-1705909773171-4ba952b9c0af?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fG9mZmljZXxlbnwwfDJ8MHx8fDA%3D",
//     },
// ];





// import { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const points = [
//   { title: "Point 1", desc: "This is description for point one." },
//   { title: "Point 2", desc: "This is description for point two." },
//   { title: "Point 3", desc: "This is description for point three." },
//   { title: "Point 4", desc: "This is description for point four." },
//   { title: "Point 5", desc: "This is description for point five." },
//   { title: "Point 6", desc: "This is description for point six." },
//   { title: "Point 7", desc: "This is description for point seven." },
//   { title: "Point 8", desc: "This is description for point eight." },
//   { title: "Point 9", desc: "This is description for point nine." },
//   { title: "Point 10", desc: "This is description for point ten." },
// ];

// export default function ScrollSwapCanvas() {
//   const [visibleCount, setVisibleCount] = useState(1);
//   const canvasRef = useRef(null);

//   // 🎨 Canvas background animation
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     canvas.width = window.innerWidth;
//     canvas.height = window.innerHeight;

//     let particles = Array.from({ length: 50 }, () => ({
//       x: Math.random() * canvas.width,
//       y: Math.random() * canvas.height,
//       r: Math.random() * 2 + 1,
//       dx: Math.random() * 0.6,
//       dy: Math.random() * 0.6,
//     }));

//     function animate() {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.fillStyle = "rgba(99,102,241,0.6)";
//       particles.forEach((p) => {
//         p.x += p.dx;
//         p.y += p.dy;
//         if (p.x > canvas.width) p.x = 0;
//         if (p.y > canvas.height) p.y = 0;
//         ctx.beginPath();
//         ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
//         ctx.fill();
//       });
//       requestAnimationFrame(animate);
//     }
//     animate();
//   }, []);

//   // 🔄 Scroll reveal logic (stacked, not swap)
//   const handleWheel = (e) => {
//     e.preventDefault();

//     if (e.deltaY > 0 && visibleCount < points.length) {
//       setVisibleCount((prev) => prev + 1);
//     }

//     if (e.deltaY < 0 && visibleCount > 1) {
//       setVisibleCount((prev) => prev - 1);
//     }
//   };

//   return (
//     <div
//       onWheel={handleWheel}
//       className="relative h-screen w-full overflow-hidden bg-gray-950"
//     >
//       <canvas ref={canvasRef} className="absolute inset-0" />

//       <div className="relative z-10 h-full w-full overflow-hidden flex justify-center">
//         <div className="w-[80%] pt-32 space-y-16">
//           <AnimatePresence>
//             {points.slice(0, visibleCount).map((item, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 120 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -120 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="bg-white/10 backdrop-blur-lg rounded-2xl p-10"
//               >
//                 <h2 className="text-4xl font-bold mb-4 text-white">
//                   {item.title}
//                 </h2>
//                 <p className="text-lg text-gray-300">{item.desc}</p>
//               </motion.div>
//             ))}
//           </AnimatePresence>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

const points = [
  { title: "Interview Mastery", desc: "Gain insider strategies to answer tough questions, showcase your strengths, and approach every interview with clarity and confidence." },
  { title: "Professional Preparation", desc: "Learn how to research job roles, decode company expectations, and walk into interviews ready, composed, and informed." },
  { title: "ATS-Friendly Resume Design", desc: "Create resumes that pass Applicant Tracking Systems, highlight your achievements, and get you shortlisted faster." },
  { title: "Recruiter Insight & Screening", desc: "Understand how HR evaluates candidates, what they filter out, and how to align your profile with real hiring expectations." },
  { title: "LinkedIn Profile Branding", desc: "Transform your LinkedIn into a personal brand—optimize your headline, summary, achievements, and digital presence to attract opportunities." },
  { title: "Post-Interview Success Tactics", desc: "Master the art of follow-ups, thank-you messages, offer discussions, and post-interview communication that leaves a strong impression." },
  { title: "Workplace Etiquette & Culture", desc: "Learn how to behave, communicate, and collaborate in corporate environments with professionalism, discipline, and maturity." },
  { title: "Communication & Ethics Excellence", desc: "Develop clarity in speech, confidence in writing, empathy in interaction, and a deep understanding of ethics that employers respect." },
  { title: "Real-Time HR Mock Interviews", desc: "Practice with HR professionals, receive actionable feedback, and improve your performance through real interview simulations." },
//   { title: "Point 10", desc: "This is description for point ten." },
];

export default function ScrollRevealCanvas() {
  const canvasRef = useRef(null);

  // 🎨 Canvas Background (SECTION-BOUND)
useEffect(() => {
  const canvas = canvasRef.current;
  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  const resize = () => {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  };
  resize();
  window.addEventListener("resize", resize);

  const particles = Array.from({ length: 80 }, () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    z: Math.random() * 1.5 + 0.5, // subtle depth
    r: Math.random() * 1.5 + 0.5, // smaller radius
    dx: (Math.random() - 0.5) * 0.2, // slower speed
    dy: (Math.random() - 0.5) * 0.2,
  }));

  function animate() {
    ctx.fillStyle = "rgba(10,14,40,0.85)"; // softer dark bg
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    particles.forEach((p) => {
      p.x += p.dx * p.z;
      p.y += p.dy * p.z;

      if (p.x < 0) p.x = canvas.width;
      if (p.x > canvas.width) p.x = 0;
      if (p.y < 0) p.y = canvas.height;
      if (p.y > canvas.height) p.y = 0;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * p.z, 0, Math.PI * 2);
      ctx.fillStyle = "rgba(99,102,241,0.5)"; // subtle neon blue
      ctx.fill();
    });

    requestAnimationFrame(animate);
  }

  animate();

  return () => window.removeEventListener("resize", resize);
}, []);


  return (
    <section className="relative bg-gray-950 min-h-screen overflow-hidden">
      {/* 🎥 CANVAS (ONLY THIS SECTION) */}
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full z-0"
      />

      {/* 🔹 HEADING */}
      <div className="relative z-10 text-center pt-32 pb-20 px-6">
        <h1 className="text-4xl md:text-5xl font-bold text-white">
          Skill Development
        </h1>
        <p className="mt-4 max-w-2xl mx-auto text-gray-300 text-base md:text-lg">
          We focus on building practical skills through structured learning,
          real-world projects, and continuous improvement to help you grow
          professionally.
        </p>
      </div>

      {/* 🔹 POINTS */}
      <div className="relative z-10 mx-auto w-[80%] pb-32 space-y-10">
        {points.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9, y: 40 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: false, amount: .9 }}
            
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="bg-white/10 backdrop-blur-md rounded-xl px-6 py-5"
          >
            <div className="flex gap-3">
              <div className="text-indigo-400 font-bold text-lg">
                {String(index + 1).padStart(2, "0")}
              </div>

              <div>
                <h2 className="text-xl font-semibold text-white">
                  {item.title}
                </h2>
                <p className="text-sm text-gray-300 mt-1 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}





